// extracted by mini-css-extract-plugin
export default {"overlay":"Ey-z","bodyOpen":"Fy-z","content":"Gy-z","header":"Hy-z","close":"Iy-z","closeNoHeading":"Jy-z"};